import React from "react";
import Navigation from "../components/Navigation";
import GestaoPedidos from "../components/data/GestaoPedidos";

const Pedidos = () => {
 return (
  <div className="container-fluid mt-4 mb-3">
    <div className="row gx-3" style={{justifyContent: 'space-around'}}>
      <div className="col-md-2" style={{maxWidth:'250px'}}>
        <Navigation activeKey="/pedidos" />
      </div>
      <div className="col-md-10">
        <h1 className="mt-4">Suporte</h1>
        <h2 className="mb-4">Consultar pedidos</h2>
        <GestaoPedidos />
      </div>
    </div>
 </div>
 );
};

export default Pedidos;
